export default {
    baseStyle: (props) => ({
        container: {
            position: 'relative',
            width: '100%',
            height: '100%'
        },

        videoWrapper: {
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'hidden'
        },

        video: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
        },

        controlsWrapper: {
            position: 'absolute',
            top: '14px',
            right: '14px',
            zIndex: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
        },

        iconButton: {
            minW: '24px',
            width: '24px',
            height: '24px',
            borderRadius: 'full',
            color: 'black',
            bg: 'rgba(255,255,255,0.9)',
            _hover: {
                bg: 'white'
            },
            _active: {
                bg: 'white'
            }
        },
        iconSize: {
            width: '24px',
            height: '24px'
        }
    }),

    variants: {},

    parts: ['container', 'videoWrapper', 'video', 'controlsWrapper', 'iconButton', 'iconSize']
}